import { FC, memo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import StarIcon from '@icons/star_required_icon.svg?component';
import { IInputCheckboxProps } from './types';

export const InputCheckbox: FC<IInputCheckboxProps> = memo(
  ({
    name,
    inputText,
    label,
    myOnBlur,
    myOnFocus,
    styleProp,
    required = false,
    showRequiredIcon = false,
    disabled = false,
  }) => {
    const { control } = useFormContext();

    return (
      // <div className={styles.inputWrapper}>
      <div className="relative flex flex-col justify-center">
        {label && <p className="subtitle">{label}</p>}
        <label
          className={`relative flex items-center pl-[32px] cursor-pointer select-none w-fit ${styleProp}`}
        >
          {required && showRequiredIcon && <StarIcon className="absolute left-[-15px] w-[10px]" />}
          {inputText && <p className="w-full small-text">{inputText}</p>}
          {/* use ts-ignore due to Type instantiation is excessively deep and possibly infinite.ts(2589) error */}
          {/* @ts-ignore */}
          <Controller
            control={control}
            name={name}
            rules={{
              required: required,
            }}
            render={({ field, field: { onChange, value }, fieldState: { error } }) => (
              <>
                <input
                  {...field}
                  className={`peer absolute h-0 w-0 opacity-0 cursor-pointer`}
                  type="checkbox"
                  checked={value}
                  onFocus={(e) => {
                    myOnFocus && myOnFocus(e.target.value);
                  }}
                  onBlur={(e) => {
                    myOnBlur && myOnBlur(e);
                  }}
                  onChange={() => {
                    onChange(!Boolean(value));
                  }}
                  disabled={disabled}
                />
                <span
                  className={`absolute top-1/2 left-0 transform -translate-y-1/2 w-[20px] h-[20px] border  rounded-[6px] ${
                    disabled ? 'bg-custom-gray' : 'bg-[#EDF5FC]'
                  } ${error ? 'border-error' : 'border-primary'}`}
                >
                  {/* Checkmark */}
                  <span
                    className={`absolute top-[20%] left-[6px] w-[6px] h-[10px] rotate-45 border-r-[2px] border-b-[2px] border-primary ${
                      value ? 'block' : 'hidden'
                    }`}
                  ></span>
                </span>
                {/* {error && !hideErrorIcon && (
                <ErrorIcon
                  name={name}
                  message={getErrorText((error?.type as string) || '', {
                    errorText,
                    patternMsg: registerPattern?.message,
                    validateErrorText: validation?.message,
                  })}
                  stylesProp={{ top: '23%' }}
                />
              )} */}
              </>
            )}
          />
        </label>
      </div>
    );
  }
);
